import _ from 'lodash';
import { makeAutoObservable } from 'mobx';

class AvatarListState {
  moreAvatarsModalOpen = false;
  size = 'sm';
  type = 'overlap';
  limit = 3;
  linkable = false;
  employees;
  moreModalEnabled = false;
  moreIndicator = 'count';

  constructor() {
    makeAutoObservable(this);
  }

  receiveProps({size, type, employees, limit, linkable, moreModalEnabled, moreIndicator}) {
    this.size = size || this.size;
    this.type = type || this.type;
    this.limit = limit || this.limit;
    this.linkable = linkable || this.linkable;
    this.employees = employees;
    this.moreModalEnabled = moreModalEnabled;
    this.moreIndicator = moreIndicator || this.moreIndicator;
  }

  openMoreAvatarsModal() {
    if (this.moreModalEnabled) {
      this.moreAvatarsModalOpen = true;
    }
  }

  closeMoreAvatarsModal() {
    this.moreAvatarsModalOpen = false;
  }

  get moreEmployeesOption() {
    return this.limit < this.employees.length;
  }

  get moreAvatar() {
    return {
      size: this.size,
      className: this.moreIndicator === 'ellipsis' ? 'Avatar--more Avatar--more--ellipsis' : 'Avatar--more',
      employee: {
        avatarInitials: this.moreInitials,
        avatarColour: 'bg-whale'
      }
    };
  }

  get moreInitials() {
    return this.moreIndicator === 'ellipsis' ? '...' : `+${this.employees.length - this.limit}`;
  }

  get employeeList() {
    return _.take(this.employees, this.limit);
  }

  get moreEmployeesList() {
    return _.difference(this.employees, this.employeeList);
  }

  calculateZIndex(index) {
    if (this.type !== 'overlap') {
      return 'auto';
    }

    return 300 - index;
  }
}

export default AvatarListState;
